  import { Input, Component } from '@angular/core';

@Component({
  selector: 'vtab-right-panel',
  templateUrl: './vtab-right-panel.component.html',
  styleUrls: ['./vtab-right-panel.component.scss'],
  standalone: false,
})
export class VTabRightPanelComponent {
  @Input() title = null;
}
